import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Patient} from '../../../model/user/Patient';
import {PrismObject} from '../../../model/questionnaires/questionnaire-prism';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app.states';
import {MatSnackBar} from '@angular/material/snack-bar';
import {QuestionnaireEvaluationComponent} from '../questionnaire-evaluation/questionnaire-evaluation.component';
import {doctorDispatching, EvaluationDTO} from '../utils';
import {BackendApi, localhost} from '../../../config/backend-api';
import {fabric} from 'fabric';

export interface PRISMDialogData {
  id: string;
  date: string;
  self: PrismObject;
  disease: PrismObject;
  distance: string;
  patientChosen: Patient;
  role: string;
  read: boolean;
  warning: boolean;
  evaluation: boolean;
}

@Component({
  selector: 'app-prism-result-dialog',
  templateUrl: './prism-result-dialog.component.html',
  styleUrls: ['./prism-result-dialog.component.css']
})
export class PRISMResultDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  diagnosis: string;

  self: PrismObject;
  disease: PrismObject;

  read: boolean;
  warning: boolean;
  evaluation: boolean;

  distance: number;

  constructor(public dialogRef: MatDialogRef<PRISMResultDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: PRISMDialogData,
              private httpClient: HttpClient,
              public dialog: MatDialog,
              private store: Store<AppState>,
              private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    console.log(this.data.role);
    console.log(this.data);

    this.self = this.data.self;
    this.disease = this.data.disease;
    this.distance = parseFloat(this.data.distance);
    console.log(this.self, this.disease);

    this.read = this.data.read;
    this.warning = this.data.warning;
    this.evaluation = this.data.evaluation;

    if (this.data.role === 'DOTTORE') {
      setTimeout(() => {
        this.read = true;
      }, 500);
    }

    if (this.distance > 1.7 && this.distance <= 2.2) {
      this.diagnosis = 'Poco influente';
    } else if (this.distance > 1.2 && this.distance <= 1.7) {
      this.diagnosis = 'Moderatamente influente';
    } else if (this.distance > 0.6 && this.distance <= 1.2) {
      this.diagnosis = 'Molto influente';
    } else if (this.distance > 0 && this.distance <= 0.6) {
      this.diagnosis = 'Totalmente influente';
    }
  }

  ngAfterViewInit(): void {
    const canvas = new fabric.Canvas('canvas');

    const x1 = this.self.x;
    const y1 = this.self.y;
    const x2 = this.disease.x;
    const y2 = this.disease.y;

    console.log(x1, y1, x2, y2);

    const disease = new fabric.Circle({
      radius: 30, left: this.disease.x, top: this.disease.y, fill: '#cc0000',
      originX: 'center', originY: 'center',
      hasControls: false, hasBorders: false, hoverCursor: 'pointer', moveCursor: 'pointer',
      stroke: '#990000', strokeWidth: 2, evented: false
    });

    const self = new fabric.Circle({
      radius: 50, left: this.self.x, top: this.self.y, fill: '#ffe014', hasControls: false, hasBorders: false,
      originX: 'center', originY: 'center', stroke: '#ffc414', strokeWidth: 2, evented: false
    });

    canvas.add(self, disease);
    canvas.selection = false;
  }

  evaluate() {
    if (this.data.role === 'DOTTORE') {
      this.dialog.open(QuestionnaireEvaluationComponent, {
        width: '500px',
        height: '290px',
        data: ['Ok', 'Segnala']
      }).afterClosed().subscribe(res => {
        if (res === undefined) {
          console.log(res);
        } else {

          const id = this.data.id.split('-');
          const date = id[0];
          const type = id[1];
          const doctorID = id[2];
          const patientSSN = id[3];

          let evaluation;

          if (res === 'Segnala') {
            // tslint:disable-next-line:max-line-length
            evaluation = new EvaluationDTO(date, false);
            this.evaluation = false;
            this.warning = true;

          } else if (res === 'Ok') {
            evaluation = new EvaluationDTO(date, true);
            this.evaluation = true;
            this.warning = false;
          }

          console.log('qua', type);

          // tslint:disable-next-line:max-line-length
          return this.httpClient.post(localhost +
            BackendApi.EVALUATE_QUESTIONNAIRE + type + '/' + doctorID + '/' + patientSSN,
            evaluation, {observe: 'response', responseType: 'text'})
            .subscribe(response => {
              if (response.status === 200) {
                if (this.data.role === 'DOTTORE') {
                  doctorDispatching(this.store, type, patientSSN);
                } else if (this.data.role === 'PAZIENTE') {
                  /*patientDispatching(this.patientService)*/
                }
                if (!evaluation.evaluation) {
                  window.location.href =
                    'mailto:' + this.data.patientChosen.email +
                    '?subject=IBD%20Tool%20-%20Segnalazione%20questionario%PRISM%20del%20' +
                    this.data.id.split('-')[0] + '&body=';
                  this.snackBar.open('Segnalazione effettuata correttamente.', 'Chiudi', {
                    duration: 2000
                  });
                } else {
                  this.snackBar.open('Valutazione effettuata correttamente.', 'Chiudi', {
                    duration: 2000
                  });
                }
              }
            });
        }
      });
    }
  }

  warn() {
    if (this.data.role === 'PAZIENTE') {
      const splitted = this.data.id.split('-');
      console.log(splitted);
      const date = splitted[0];
      const type = splitted[1];
      const doctorID = splitted[2];
      const patientSSN = splitted[3];
      // tslint:disable-next-line:max-line-length
      return this.httpClient.post(localhost + BackendApi.WARN_DOCTOR + type + '/' + doctorID + '/' + patientSSN, date, {observe: 'response', responseType: 'text'})
        .subscribe(res => {
          if (res.status === 200) {
            this.evaluation = false;
            this.warning = true;
            this.snackBar.open('Segnalazione effettuata correttamente.', 'Chiudi', {
              duration: 2000
            });
            // tslint:disable-next-line:max-line-length
            window.location.href = 'mailto:' + this.data.patientChosen.doctor.email +
              '?subject=IBD%20Tool%20-%20Segnalazione%20questionario%PRISM%20del%20' + date + '&body=';
          }
        });
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    const id = this.data.id.split('-');
    let type = '';
    let patientSSN = '';
    if (id.includes('CLINICAL')) {
      type = id[1] + '-' + id[2];
      patientSSN = id[4];
    } else {
      type = id[1];
      patientSSN = id[3];
    }
    if (this.data.role === 'DOTTORE') {
      doctorDispatching(this.store, type, patientSSN);
    } else if (this.data.role === 'PAZIENTE') {
      /*patientDispatching(this.patientService)*/
    }
  }
}
